const YMM_STORAGE_KEY = 'selected_ymm_vehicle';

const YMMStorage = {
  save(handle, displayName) {
    const data = { handle, displayName, timestamp: Date.now() };
    localStorage.setItem(YMM_STORAGE_KEY, JSON.stringify(data));
  },

  get() {
    const data = localStorage.getItem(YMM_STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  },

  clear() {
    localStorage.removeItem(YMM_STORAGE_KEY);
    window.location.reload();
  }
};

function initYmmSelector(container) {
  if (!container || container.dataset.initialized) return;
  
  const ymmselector = document.getElementById('ymm-selector');
  const config = { token: ymmselector.dataset.token, domain: ymmselector.dataset.domain, api: '2026-01' };

  const elMerk = document.getElementById('select-merk');
  const elModel = document.getElementById('select-model');
  const elType = document.getElementById('select-type');
  const btnSearch = document.getElementById('btn-search');

  async function shopifyQuery(query, variables) {
    
    const response = await fetch(`https://${config.domain}/api/${config.api}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': config.token,
      },
      body: JSON.stringify({ query, variables })
    });

    const result = await response.json();

    if (result.errors) { return null; }
    return result.data;
  }

  async function loadActiveMakes() {
    const query = `{
      metaobjects(type: "automerken", first: 100) {
        edges {
          node {
            id
            handle
            naam: field(key: "naam") { value }
          }
        }
      }
    }`;
    
    const data = await shopifyQuery(query, {});
    const makes = data.metaobjects.edges.map(e => ({ id: e.node.id, naam: e.node.naam.value, handle: e.node.handle }));
    
    makes.sort((a, b) => a.naam.localeCompare(b.naam));
    renderOptions(elMerk, makes);
  }

  async function loadModelsForMake(makeId = "", handle = "") {

    const elModel = document.getElementById('select-model');
    
    const query = `query BrandByHandle($handle: MetaobjectHandleInput!) {
        metaobject(handle: $handle) {
          handle
          subs: field(key: "automodellen") {
            references(first: 50) {
              nodes {
                __typename
                ... on Metaobject {
                  handle
                  name: field(key: "naam") {
                    value
                  }
                }
              }
            }
          }
        }
      }`;

    const variables = {
      "handle": {
        "type": "automerken",
        "handle": handle
      }
    };

    const data = await shopifyQuery(query, variables);

    const model = data.metaobject;
    if (!model) {
      return null; // no metaobject found for this handle
    }

    // Extract subs from the references list
    const rawSubRefs = model.subs?.references?.nodes ?? [];
    const subs = rawSubRefs
      .filter((node) => node.__typename === 'Metaobject')
      .map((sub) => ({
        handle: sub.handle,
        naam: sub.name?.value ?? null,
      }));

    subs.sort((a, b) => a.naam.localeCompare(b.naam));

    renderOptions(elModel, subs);
    elModel.disabled = false;
  }

  async function loadTypesForModel(modelId = '', handle = '') {
    
    const query = `query ModelByHandle($handle: MetaobjectHandleInput!) {
        metaobject(handle: $handle) {
          handle
          subs: field(key: "autotypes") {
            references(first: 50) {
              nodes {
                __typename
                ... on Metaobject {
                  handle
                  name: field(key: "naam") {
                    value
                  }
                  chandle: field(key: "collection_handle") {
                    value
                  }
                }
              }
            }
          }          
        }
      }`;

    const variables = {
      "handle": {
        "type": "automodellen",
        "handle": handle
      }
    };

    const data = await shopifyQuery(query, variables);

    const model = data.metaobject;
    if (!model) {
      return null; // no metaobject found for this handle
    }

    const rawSubRefs = model.subs?.references?.nodes ?? [];
    const subs = rawSubRefs
      .filter((node) => node.__typename === 'Metaobject')
      .map((sub) => {
        const collectionRef = sub.collection?.reference;
        const collection =
          collectionRef && collectionRef.__typename === 'Collection'
            ? {
                id: collectionRef.id,
                handle: collectionRef.handle,
                url: collectionRef.onlineStoreUrl,
              }
            : null;

        return {
          handle: sub.handle ?? null,
          naam: sub.name?.value ?? null,
          chandle: sub.chandle?.value ?? null
          //collection,
        };
      });

    subs.sort((a, b) => a.naam.localeCompare(b.naam));

    renderOptions(elType, subs, true);
    elType.disabled = false;
  }

  
  function renderOptions(element, data, dataset = false) {
    element.innerHTML = `<option value="">${element.dataset.seltext}</option>`;
    data.forEach(item => {
      const opt = document.createElement('option');
      opt.value = item.handle;
      opt.textContent = item.naam;
      if(dataset == true) opt.dataset.url = item.chandle;
      element.appendChild(opt);
    });
  }

  /**
   * Event Listeners voor UX flow
   */
  elMerk.addEventListener('change', () => {
    resetSelect(elModel);
    resetSelect(elType);
    btnSearch.disabled = true;
    if (elMerk.value) loadModelsForMake(elMerk.value, elMerk.value);
  });

  elModel.addEventListener('change', () => {
    resetSelect(elType);
    btnSearch.disabled = true;
    if (elModel.value) loadTypesForModel(elModel.value, elModel.value);
  });

  elType.addEventListener('change', () => {
    if(elType.value) btnSearch.disabled = false; 
  });

  btnSearch.addEventListener('click', () => {
    const selectedOption = elType.options[elType.selectedIndex];
    const handle = selectedOption ? selectedOption.dataset.url : null;

  
    if (handle && handle !== "") {
      // Opslaan voor de volgende keer
      // YMMStorage.save(selectedOption.value, selectedOption.textContent);
      // Redirect naar de collectie pagina
      window.location.href = `/collections/${handle}`;
    } else {
      console.log("Error in car selector");
    }

  });

  function resetSelect(el) {
    el.innerHTML = `<option value="">${el.dataset.resettext}</option>`;
    el.disabled = true;
  }

  loadActiveMakes();
  container.dataset.initialized = "true";
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('ymm-selector');
  initYmmSelector(container);
});

document.addEventListener('shopify:section:load', (event) => {
  const container = event.target.querySelector('#ymm-selector');
  initYmmSelector(container);
});